import React from "react";

interface LockIconProps {
  className?: string;
}

export const LockIcon: React.FC<LockIconProps> = ({ className, ...other }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    className={className}
    {...other}
  >
    <path
      d="M9.5625 5.8125V4.6875C9.5625 3.1125 8.325 1.875 6.75 1.875C5.175 1.875 3.9375 3.1125 3.9375 4.6875V5.8125C2.98125 5.8125 2.25 6.54375 2.25 7.5V11.4375C2.25 12.3938 2.98125 13.125 3.9375 13.125H9.5625C10.5188 13.125 11.25 12.3938 11.25 11.4375V7.5C11.25 6.54375 10.5188 5.8125 9.5625 5.8125ZM5.0625 4.6875C5.0625 3.73125 5.79375 3 6.75 3C7.70625 3 8.4375 3.73125 8.4375 4.6875V5.8125H5.0625V4.6875Z"
      fill="currentColor"
    />
  </svg>
);
